module.exports = __webpack_public_path__ + "img/dominicanrepublic.86339df3.svg";